export const getInPageNavItemsFromBlocks = (blocks: any) => {
  if (!blocks || !Array.isArray(blocks)) return []

  return blocks
    .filter((item: any) => item?.moduleId)
    .map((item: any) => ({
      title: item.moduleId.split('-').join(' '),
      slug: item.moduleId,
    }))
}
